import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";

const BillHeader = ({ title, date, noDateAndTime }) => {
  const today = date ? new Date(date) : new Date();
  const header = JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION))
    ?.stockLocationDetail?.posHeader;

  return (
    <>
      <div className="bill-reportHeader">
        <div dangerouslySetInnerHTML={{ __html: header }} />

        {/* <div
          style={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: 14,
            textTransform: "uppercase",
          }}
        >
          {title}
        </div> */}
      </div>

      {/* <div>
        {noDateAndTime ? null : (
        <div className="space-between mb" style={{ marginLeft: 10 , marginTop: 40}}>
          <Typography className="header-label">
            <span> Printed Date:&nbsp; {today.toDateString()}</span>
          </Typography>
          <Typography className="header-label"  style={{ marginRight: 20}}>
            <span> Printed Time: &nbsp; {today.toLocaleTimeString()}</span>
          </Typography>
        </div>
      )}
        </div> */}
    </>
  );
};

export default BillHeader;
